import EMPTY_EMAIL_MESSAGE from './sample/empty-email-message';

export default function getConfiguration(_template?: string) {
  return EMPTY_EMAIL_MESSAGE;
}
